module.exports = __webpack_public_path__ + "static/media/carousel_banner_3.f80f2aa5.png";